module.exports = __webpack_public_path__ + "static/media/referral-rightbg.da608b9e.png";